export default "__VITE_ASSET__yySga17u__"